import * as types from '../actions/actionTypes';
import initialState from './initialState';

export default function preguntaComboReducer(state= initialState.preguntaCombo, action){
	switch(action.type){
		case types.GET_PREGUNTAS_COMBO_SUCCESS:		            
			return action.datos;		
	
		default:
			return state;
	}
}